import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import { Icon } from 'src/components/atoms/icon';
import Pagination from 'src/components/atoms/pagination/pagination';
import Spinner from 'src/components/atoms/spinner/spinner';
import Table from 'src/components/atoms/table/table';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { openModal } from 'src/reducers/modal.reducer';
import { getParamsFromUrl, setParamsToUrl, userDefaultParams } from 'src/utils/pagination-utils';
import { getUsers } from '../../../reducers/user.reducer';
import { EDIT_ANAGRAPHIC_PERMISSION, isAuthorizedToHandleCapability } from '../../../utils/capability-utils';
import { CreateEmployee } from './employeesModals/createEmployee';
import { EmployeesTableCard } from './employeesTable/employeesTableCard';
import { EmployeesTableHeader } from './employeesTable/employeesTableHeader';
import styles from './employes.module.scss';

const Employees = () => {
  const dispatch = useAppDispatch();
  const { users, totalItems, refresh, loading, failure, success } = useAppSelector(state => state.user);
  const { user } = useAppSelector(state => state.authentication);
  const navigate = useNavigate();
  const location = useLocation();

  const [params, setParams] = useState(getParamsFromUrl(userDefaultParams, location));

  const createEmployee = () => {
    dispatch(
      openModal({
        children: <CreateEmployee />,
        opt: {
          size: 'sm',
          type: 'default',
          title: 'Crea dipendente',
        },
      })
    );
  };

  const handlePagination = (page: number) => {
    setParams(prevState => ({
      ...prevState,
      currentPage: page + 1,
    }));
  };

  useEffect(() => {
    dispatch(getUsers({ pagination: params }));
    setParamsToUrl(params, navigate);
  }, [dispatch, navigate, params, params.currentPage, params.sortBy, params.sortDirection, refresh]);

  if (loading) {
    return <Spinner className={styles.spinner} />;
  }

  return (
    <>
      {!loading && failure && <div className="m-1">Errore nel caricamento dei dipendenti</div>}
      {!loading && success && users.length === 0 && <div className="m-1">Nessun dipendente trovato.</div>}
      {!loading && success && user && users.length > 0 && (
        <>
          <Table>
            <Table.Header>
              <EmployeesTableHeader />
            </Table.Header>
            <Table.Body>
              {users.map(employee => (
                <EmployeesTableCard employee={employee} key={employee.id} />
              ))}
            </Table.Body>
          </Table>
          <Pagination
            activePage={params.currentPage - 1}
            itemsPerPage={params.postPerPage}
            totalItems={totalItems || 0}
            paginate={handlePagination}
          />
        </>
      )}

      {user && isAuthorizedToHandleCapability(user, EDIT_ANAGRAPHIC_PERMISSION) && (
        <Button className={styles.addButtonSticky} color="black" mode="solid" size="md" circle onClick={createEmployee}>
          <Icon content="add" size="sm" color="white" />
        </Button>
      )}
    </>
  );
};

export default Employees;
